import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslationService } from '../configuration/translation-service';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messageService = inject(MessageService);
  private translationService = inject(TranslationService);

  success(message: string, summary = 'Success') {
    this.messageService.add({
      severity: 'success',
      summary,
      detail: this.translationService.translate(message),
      life: 3000
    });
  }

  error(message: string | string[], summary = 'Error') {
    const detail = Array.isArray(message) ? message.map((msg, i) => `${i + 1}. ${msg}`).join('\n') : message;

    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life: 3000
    });
  }

  warn(message: string, summary = 'Warning') {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail: message,
      life: 3000
    });
  }

  info(message: string, summary = 'Info') {
    this.messageService.add({
      severity: 'info',
      summary,
      detail: message,
      life: 3000
    });
  }
}
